<template>
  <div class="images" :class="{ 'images--no-results': !hasResults }">
    <EHeading id="images-heading" class="images__title" data-test-id="images-title">
      {{ $t('images.title') }}
    </EHeading>
    <section v-if="hasResults" class="images__results">
      <EQueryExpansions
        v-show="queryExpansionsShown"
        :expansions="queryExpansions"
      />
      <EImageFeed
        v-if="!resultsLoading"
        :images="results"
        :pages="pages"
        :total-results="count"
        aria-labelledby="images-heading"
      />
      <EPagination
        v-if="paginationShown && !resultsLoading"
        :current="page"
        :pages="pages"
        class="images__pagination"
        data-test-id="images-pagination"
      />
    </section>
    <ENoResults
      v-else
      :query="query"
      :error="error"
      data-test-id="images-no-results"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { isDesktopUp } from '~~/common/js/client/screen';

import firstSearchAfterInstall from '~~/common/vue/mixins/first-search-after-install';
import EHeading from '~~/common/vue/components/heading';
import ENoResults from '~~/search/common/vue/components/no-results';
import EPagination from '~~/common/vue/components/pagination';

import EImageFeed from '~/components/image-feed';
import EQueryExpansions from '~/components/query-expansions';

export default {
  components: {
    EImageFeed,
    EHeading,
    ENoResults,
    EPagination,
    EQueryExpansions,
  },
  mixins: [firstSearchAfterInstall],
  data: () => ({
    paginationShown: true,
  }),
  computed: {
    ...mapState('global', ['locale']),
    ...mapState('search', ['filtersShown']),
    ...mapState(['error', 'count', 'pages', 'results', 'queryExpansions', 'resultsLoading']),
    ...mapGetters(['hasResults']),
    query() {
      return this.$route.query.q;
    },
    page() {
      return this.$route.query.p ? parseInt(this.$route.query.p, 10) : 0;
    },
    queryExpansionsShown() {
      return !this.filtersShown || isDesktopUp();
    },
  },
  mounted() {
    this.paginationShown = !window.IntersectionObserver;
  },
};
</script>

<style lang="scss" scoped>
.images {
  font-size: $font-s;
  padding-bottom: $space-2l;

  @include desktop {
    padding-bottom: $space-2l * 2;
  }
}

.images__title {
  @extend %sr-only;
}

.images__pagination {
  padding-top: $space-1l;
  max-width: none;

  @include desktop {
    padding-top: $space-l;
  }
}

.images__results {
  margin-top: $space-s;
  position: relative;

  @include desktop {
    margin-top: $space-m;
  }
}

.images--no-results {
  box-sizing: content-box;
  padding: $space-s $space-s $space-2l;

  @include desktop {
    max-width: $page-container-width-desktop;
    padding: $space-2l $page-container-left-space-desktop $space-2l * 2;
  }
}
</style>
